// extracted by mini-css-extract-plugin
export default {"wrapper":"app-footer_wrapper__7Q2+l","root":"app-footer_root__+PV4C","links":"app-footer_links__6bnok"};